var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parallax-vertical__container"},[_c('div',{ref:"asset",staticClass:"parallax-vertical__asset"},[_vm._t("asset")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }